import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { useDispatch } from 'react-redux'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import AuthorizationInformationContent from '../authorizationInformationContent/AuthorizationInformationContent.component'
import { saveAuthorizationInfo } from '../store/authorizationInformation.actions'

const AuthorizationInformation: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const history = useHistory()
  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.BILLING)
  }

  const saveOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(saveAuthorizationInfo())
  }

  return (
    <IonPage id='AuthorizationInformationPage'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton data-testid='Save' color='primary-alt' fill='clear' onClick={saveOnClick}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('authorizationInformation.AuthorizationInformation')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent id='main-pn-content' color='light' fullscreen>
        <AuthorizationInformationContent />
      </IonContent>
    </IonPage>
  )
}

export default AuthorizationInformation
